import { Component, Input } from '@angular/core';
import { SpecialFormControl } from '@utilities/SpecialForms';

@Component({
  selector: 'control-image-picker',
  templateUrl: './control-image-picker.component.html',
  styleUrls: ['./control-image-picker.component.scss']
})
export class ControlImagePickerComponent {

  @Input() sfcontrol: SpecialFormControl;


  imageReturned( data: string ): void {
    this.sfcontrol.markAsDirty();
    this.sfcontrol.setValue( data );
  }

}